import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";


const MasterDropdownsList = Loadable(
  lazy(() =>
    import("./MasterDropdownsList").then(({ MasterDropdownsList }) => ({
      default: MasterDropdownsList,
    }))
  )
);

export const masterDropdownsRoutes = [
  {
    path: `/settings/master-dropdowns`,
    exact: true,
    element: (
      <AuthorizedRoute  moduleKeys={[MODULE_IDS.MASTER_DROPDOWNS]}>
        <MasterDropdownsList />
      </AuthorizedRoute>
    ),
  },
]